import { type ProjectCode } from '@constants'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  scrollRow: {
    scrollbarWidth: 'none',
    overflowX: 'auto',
  },
})

export interface CsvBrandFilterChipsProps {
  brands: ProjectCode[]
  brandNameMap: Partial<Record<ProjectCode, string>>
  /** null 表示「全部」 */
  value: ProjectCode | null
  onChange: (value: ProjectCode | null) => void
}

export const CsvBrandFilterChips = ({ brands, brandNameMap, value, onChange }: CsvBrandFilterChipsProps) => {
  const renderChip = (projectCode: ProjectCode | null, label: string) => {
    const isActive = projectCode === value
    return (
      <Chip key={projectCode ?? 'all'} p={1} color={isActive ? 'red' : 'default'} selected={isActive} isOutlined onClick={() => onChange(projectCode)}>
        {label}
      </Chip>
    )
  }

  return (
    <HStack gap={3} flexWrap="nowrap" rootStyle={styles.scrollRow}>
      {renderChip(null, '全部')}
      {brands.map(projectCode => renderChip(projectCode, brandNameMap[projectCode] ?? projectCode))}
    </HStack>
  )
}
